export default "__VITE_ASSET__BFTeN_AR__"